export default __webpack_public_path__ + "static/media/nodes.eba0f7b4.md";